import { render, staticRenderFns } from "./MentionPanel.vue?vue&type=template&id=22284f6a&scoped=true"
import script from "./MentionPanel.vue?vue&type=script&lang=js"
export * from "./MentionPanel.vue?vue&type=script&lang=js"
import style0 from "./MentionPanel.vue?vue&type=style&index=0&id=22284f6a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22284f6a",
  null
  
)

export default component.exports